<div class="main">
  @if (config) {
    <app-navbar />
  }
  <div class="main-content" [class.page-background]="usePageBackground()">
    <router-outlet />
  </div>
  @if (config) {
    <app-footer />
  }
</div>
